// utils/RecorderScript.jsx
"use client";
import { useEffect } from "react";

export default function RecorderScript() {
  useEffect(() => {
    // Skip in development — HMR causes DOM conflicts
    if (process.env.NODE_ENV === "development") return;

    if (document.querySelector('script[src*="recorder.js"]')) return;

    const script = document.createElement("script");
    script.src = "https://lf-cro.blr1.cdn.digitaloceanspaces.com/recorder.js";
    script.async = true;
    script.dataset.teamId = "2";
    script.dataset.domainId = "19";
    script.dataset.host = "imagive.ai";
    script.dataset.apiUrl = "https://crux.lyxelandflamingo.com";

    try {
      document.head.appendChild(script);
    } catch (e) {
      console.warn("RecorderScript injection skipped:", e.message);
    }
  }, []);

  return null;
}
